import options from './export.component';

export default {
    selector: 'dtExportPage',
    options
};
